import React from "react";
import { MDBContainer } from "mdbreact";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet";

import Layout from "../components/Layout";

import ColourImage from "../components/ColourImage";

import text from "../text/text.json";

import header from "../images/headers/ABHeader.jpg";

import blank from "../images/aboutSIDE.jpg";

import statement from "../images/artist-statement.jpg";

import author from "../images/AuthorStatement.PNG";

function About() {
  return (
    <>
      <Helmet>
        <title>Artistic Wizard | About Us</title>
      </Helmet>
      <Layout>
        <ColourImage image={header} />
        <MDBContainer style={{ padding: "20px" }}>
          <ReactMarkdown>{text.about.header2}</ReactMarkdown>
          <img src={blank} alt="" style={{float: 'right', margin: '10px', maxHeight:'50vh'}}/>
          <ReactMarkdown>{text.about.body1}</ReactMarkdown>
          <ReactMarkdown>{text.about.body2}</ReactMarkdown>
          <ReactMarkdown>{text.about.header3}</ReactMarkdown>
          <ReactMarkdown>{text.about.body3}</ReactMarkdown>
          <ReactMarkdown>{text.about.header4}</ReactMarkdown>
          <ReactMarkdown>{text.about.body4}</ReactMarkdown>
          <img src={statement} alt="artist statement" style={{display: 'block', 'margin-left': 'auto', 'margin-right': 'auto'}}/>
          <br/>
          <img src={author} alt="" style={{display: 'block', 'margin-left': 'auto', 'margin-right': 'auto', maxHeight:'5vh'}}/>
        </MDBContainer>
      </Layout>
    </>
  )
}

export default About;